/*
openbikebox Frontend
Copyright (C) 2021 binary butterfly GmbH

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import {Decimal} from 'decimal.js';

export const formatAccount = (row) => {
    if (!row.account_identifier || !row.account_type)
        return '';
    return row.account_identifier.substr(0, 4) + '...' + row.account_identifier.substr(row.account_identifier.length - 2);
};

export const formatPrice = (value) => {
    if (!value) {
        return '0,00 €'
    }
    if (value || value === 0) {
        value = new Decimal(value);
        value = value.toFixed(2);
        return value.replace('.', ',') + ' €';
    }
    return value;
};
